module.exports = __webpack_public_path__ + "static/webinar-dr-princenthal-c09dde0018bcd28a8101b7f72687a159.jpg";